require('./style.styl')
require('@driftt/medium-editor-embed-button/dist/css/medium-editor-embed-button.css')
import IconSVG from 'svg-inline-react'
import ReactDOMServer from 'react-dom/server'
import { IFRAMELY_KEY } from 'constants/ResourcesConstants'

const BOLD_ICON = ReactDOMServer.renderToString(
  <IconSVG
    style={{ width: 8, height: 12 }}
    element="div"
    src={require('!svg-inline?removeTags=true!./images/bold.svg')}
  />
)
const ITALIC_OPTION = ReactDOMServer.renderToString(
  <IconSVG
    style={{ width: 7, height: 12 }}
    element="div"
    src={require('!svg-inline?removeTags=true!./images/italic.svg')}
  />
)
const UNDERLINE_ICON = ReactDOMServer.renderToString(
  <IconSVG
    style={{ width: 9, height: 12 }}
    element="div"
    src={require('!svg-inline?removeTags=true!./images/underline.svg')}
  />
)

const ANCHOR_ICON = ReactDOMServer.renderToString(
  <IconSVG
    style={{ width: 12.5, height: 12.5 }}
    element="div"
    src={require('!svg-inline?removeTags=true!./images/link.svg')}
  />
)

const QUOTE_ICON = ReactDOMServer.renderToString(
  <IconSVG
    style={{ width: 12, height: 11 }}
    element="div"
    src={require('!svg-inline?removeTags=true!./images/quotes.svg')}
  />
)

const CHECK_MARK = ReactDOMServer.renderToString(
  <IconSVG
    style={{ width: 11, height: 8.5 }}
    element="div"
    src={require('!svg-inline?removeTags=true!./images/check-mark.svg')}
  />
)

const CROSS = ReactDOMServer.renderToString(
  <IconSVG
    style={{ width: 10, height: 10 }}
    element="div"
    src={require('!svg-inline?removeTags=true!./images/cross.svg')}
  />
)

const PLAYER_ICON = ReactDOMServer.renderToString(
  <IconSVG
    style={{ width: 12, height: 10 }}
    element="div"
    src={require('!svg-inline?removeTags=true!./images/youtube.svg')}
  />
)

const buttonsForSavedReply = [
  { name: 'bold', contentDefault: BOLD_ICON },
  { name: 'italic', contentDefault: ITALIC_OPTION },
  {
    name: 'anchor',
    placeholderText: 'URL',
    contentDefault: ANCHOR_ICON,
    formSaveLabel: CHECK_MARK,
    formCloseLabel: CROSS,
    linkValidation: true,
  },
]

const defaultButtons = [
  { name: 'bold', contentDefault: BOLD_ICON },
  { name: 'italic', contentDefault: ITALIC_OPTION },
  { name: 'underline', contentDefault: UNDERLINE_ICON },
  {
    name: 'anchor',
    placeholderText: 'URL',
    contentDefault: ANCHOR_ICON,
    formSaveLabel: CHECK_MARK,
    formCloseLabel: CROSS,
    linkValidation: true,
  },
  { name: 'quote', contentDefault: QUOTE_ICON },
]

const DEFAULT_OPTIONS = (isSavedReplyEditor) => ({
  autoLink: false,
  targetBlank: true,
  extensions: {},
  toolbar: {
    buttons: isSavedReplyEditor ? buttonsForSavedReply : defaultButtons,
  },
})

export class InlineEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = { text: props.text }
  }

  componentDidMount() {
    require.ensure(
      [
        'medium-editor',
        './FileDragging',
        '@driftt/medium-editor-embed-button/dist/js/medium-editor-embed-button',
      ],
      require => {
        // TODO Temp hack, should really cancel this callback on componentWillUnmount
        // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
        if (!this.inputNode) return
        const MediumEditor = require('medium-editor')
        window.MediumEditor = MediumEditor // this is a horrible hack for the embed plugin to work
        const { FileDragging } = require('./FileDragging')

        let extensions = {}

        if (this.props.options && this.props.options.noImageDragging) {
          extensions = { imageDragging: {}}
        } else {
          extensions = { fileDragging: new FileDragging() }
        }

        if (this.props.options && this.props.options.videoEmbedding) {
          const EmbedButtonExtension = require('@driftt/medium-editor-embed-button/dist/js/medium-editor-embed-button')
          extensions.embedButton = new EmbedButtonExtension({
            contentDefault: PLAYER_ICON,
            embedOpts: {
              oembedProxy: `https://iframe.ly/api/iframely?key=${IFRAMELY_KEY}&iframe=true&omit_script=true&url=`,
            },
          })
        }

        const dom = this.inputNode
        this.medium = new MediumEditor(
          dom,
          Object.assign({}, DEFAULT_OPTIONS(this.props.isSavedReplyEditor), { extensions }, this.props.options)
        )
        this.medium.subscribe('editableClick', () => {
          if (this.medium) this.medium.saveSelection.bind(this.medium)()
        })
        this.medium.subscribe('focus', () => {
          setTimeout(() => {
            if (this.medium) this.medium.restoreSelection.bind(this.medium)()
          }, 1)
        })
        this.medium.subscribe('editableInput', e => {
          this._updated = true
          _.each(dom.querySelectorAll('span[style]'), sp => {
            sp.removeAttribute('style')
          })
          this.change(dom.innerHTML)
          if (this.medium) this.medium.saveSelection()
        })
      }
    )
  }

  componentWillUnmount() {
    this.medium && this.medium.destroy()
    delete window.MediumEditor
  }

  componentDidUpdate() {
    // Horrible hack to get placeholders to change
    // we should figure out a better way somehow
    const placeholderElement = document.getElementsByClassName('medium-editor-placeholder')
    if (placeholderElement && placeholderElement[0]) {
      placeholderElement[0].setAttribute(
        'data-placeholder',
        this.props.options && this.props.options.placeholder
          ? this.props.options.placeholder.text
          : ''
      )
    }
  }

  componentWillReceiveProps(nextProps) {
    // Not proud of this whole hack but it is needed for some control on when this component needs to update
    // its text from prop
    if (nextProps.text === '' || (nextProps.text !== this.props.text && !this._updated)) {
      this.setState({ text: nextProps.text })
      this.medium && this.medium.setContent(nextProps.text)
    }

    if (this._updated) this._updated = false
  }

  change(text) {
    if (this.props.onChange) this.props.onChange(text, this.medium)
  }

  render() {
    const { tag, dangerouslySetInnerHTML, text, options, ...props } = this.props
    const newProps = Object.assign(props, {
      dangerouslySetInnerHTML: { __html: this.state.text },
    })
    return <div contentEditable={true} ref={c => (this.inputNode = c)} {...newProps} />
  }
}

InlineEditor.defaultProps = { tag: 'div' }



// WEBPACK FOOTER //
// ./src/scripts/components/shared/InlineEditor/index.jsx